import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './localizations/en.json';
import baTranslations from './localizations/ba.json';
import deTranslations from './localizations/de.json';

const resources = {
    us: { translation: enTranslations },
    de: { translation: deTranslations },
    ba: { translation: baTranslations }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: 'ba',
        interpolation: {
            escapeValue: false // React already escapes values
        }
    });

export default i18n;
